import React from "react";
import AutoCompleteComponent from "../../component/AutoCompleteComponent/AutoCompleteComponent";

const AutoComplete = ({
  data,
  formcallback,
  rowsdataID,
  Automod,
  isDisabledTable,
  autoSelectObj,
  rowsdataFree,
  formIsSubmited,
  formaction,
  errors,
  isSubmited,
  handleClickOpen,
  textValue1,
  id,
  setallAccountData,
  setselectedAUTOCOMPLETE,
  selectAndAutocompleteSname,
  params,
  summary,
  mainData,
  helperTextHeight,
  emptyHelperText = " ",
  handleItemClear,
  rowScoped,
  resetSignal,
}) => {
  const fieldName = data?.component?.sName;
  const valueField = data?.data?.sValueField || fieldName;
  const isMultiValue = data?.component?.options?.mode === "MULTIVALUE";

  const getRawSavedValue = () => {
    if (rowsdataID !== undefined && rowsdataID !== null && rowsdataID !== "") {
      return rowsdataID;
    }

    if (textValue1?.[fieldName] !== undefined && textValue1?.[fieldName] !== null && textValue1?.[fieldName] !== "") {
      return textValue1[fieldName];
    }

    const mainRecord =
      mainData?.data?.mainrecord ||
      mainData?.mainrecord ||
      mainData ||
      {};

    if (mainRecord?.[fieldName] !== undefined && mainRecord?.[fieldName] !== null && mainRecord?.[fieldName] !== "") {
      return mainRecord[fieldName];
    }

    return data?.component?.sDefaultValue || "";
  };

  const autovaluedata = (e, e2) => {
    const selectedValues = Array.isArray(e2) ? e2 : e2 ? [e2] : [];

    const value = selectedValues
      .map((item) => {
        if (typeof item === "string") return item;
        return item?.[valueField] ?? item?.[fieldName] ?? "";
      })
      .filter(Boolean)
      .join(",");

    formcallback(
      {
        target: {
          name: fieldName,
          value,
        },
      },
      {
        [fieldName]: value,
      },
      e2
    );
  };

  return (
    <AutoCompleteComponent
      data={data}
      isDisabledTable={isDisabledTable}
      handleClickOpen={handleClickOpen}
      autovaluedata={autovaluedata}
      setallAccountData={setallAccountData}
      autoValue={data?.data?.sDataSource}
      id={id}
      rowvalue={getRawSavedValue()}
      errors={errors}
      autoSelectObj={autoSelectObj}
      autoValue1={data?.data?.data?.sDataSource}
      rowsdataFree={rowsdataFree}
      Automod={Automod}
      setselectedAUTOCOMPLETE={setselectedAUTOCOMPLETE}
      textValue1={textValue1}
      formaction={formaction}
      isSubmited={isSubmited}
      formIsSubmited={formIsSubmited}
      selectAndAutocompleteSname={selectAndAutocompleteSname}
      params={params}
      summary={summary}
      mainData={mainData}
      helperTextHeight={helperTextHeight}
      emptyHelperText={emptyHelperText}
      handleItemClear={handleItemClear}
      rowScoped={rowScoped}
      resetSignal={resetSignal}
      isMultiValue={isMultiValue}
      valueField={valueField}
    />
  );
};

export default AutoComplete;
